<script lang="ts">
    import {
        Button,
        StructuredList, 
        StructuredListHead, 
        StructuredListBody, 
        StructuredListRow, 
        StructuredListCell,
        InlineLoading,
        Search
    } from "carbon-components-svelte"
    import SelectBuilding from "./SelectBuilding.svelte";
    import type {Requests} from "../libreries/Requests";
    import {selectedTenant, selectedBuilding} from "../stores";
    import type { Building } from "../models/Building";
    import { onMount } from "svelte";
    import type { Checkin } from "../models/Checkin";
    import type { Tenant } from "../models/Tenant";
    import { Helpers } from "../utilities/Helpers";
    import moment from "moment";
    
    $: query = "";
    export let requests: Requests;
    let building: Building;
    let checkins: Checkin[] = [];
    let tenant: Tenant;
    let promise: Promise<any>;

    onMount(() => {
        selectedTenant.subscribe((value) => {
            tenant = value;
        })
        selectedBuilding.subscribe((value) => {
            building = value;
            if(building){
                if(building.id !== ""){
                    promise = getCheckins();
                }
            }
        })
    })

    async function getCheckins(){
        checkins = await requests.getBuildingCheckins(tenant.id, building.id, query);
    }

    function search(){
        promise = getCheckins();
    }
</script>

<SelectBuilding requests={requests} />
{#if building}
    {#if building.id === ""}
        <h6 class="margin-top-32">Selezionare un building</h6>
    {:else} 
        <h4 class="margin-top-64 margin-bottom-16">
            Check-in building {building.name} del {(moment(new Date())).format('DD-MMM-YYYY')}
        </h4>
        <div class="flex-container">
            <Search bind:value={query} placeholder="Cerca per nome o cognome" />
            <Button type="button" on:click={() => search()} >Cerca</Button>
        </div>      
        <StructuredList>
            <StructuredListHead>
            <StructuredListRow head class="header-row">
                <StructuredListCell head>Data</StructuredListCell>       
                <StructuredListCell head>Nome</StructuredListCell>
                <StructuredListCell head>Tipologia</StructuredListCell>
                <StructuredListCell head>Check-in</StructuredListCell>
                <StructuredListCell head>Check-out</StructuredListCell>
            </StructuredListRow>
            </StructuredListHead>
            <StructuredListBody>
                {#await promise}
                <InlineLoading />
                {:then}
                    {#if checkins.length > 0}
                        {#each checkins as checkin, index}
                            <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
                                <StructuredListCell>{checkin.checkinDate}</StructuredListCell>
                                <StructuredListCell>{checkin.identity}</StructuredListCell>
                                <StructuredListCell>{Helpers.switchUserType(checkin.identityType)}</StructuredListCell>
                                <StructuredListCell>{checkin.checkinTime}</StructuredListCell>
                                <StructuredListCell>
                                    {#if !checkin.checkoutTime}
                                    -
                                    {:else}
                                    {checkin.checkoutTime}
                                    {/if}
                                </StructuredListCell>
                            </StructuredListRow>
                        {/each}      
                    {:else}
                        <h6 style="margin: 2rem">Nessun check-in</h6>
                    {/if}
                {/await}
            </StructuredListBody>
        </StructuredList>
    {/if}
{:else}
    <h6 class="margin-top-32">Selezionare un building</h6>
{/if}